var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_feather-mouse-pointer",
    "data-name": "Icon feather-mouse-pointer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.596,
    height: 12.596,
    viewBox: "0 0 12.596 12.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32895",
    "data-name": "Tracciato 32895",
    d: "M15.1,4.5,10.681,15.1,9.114,10.482,4.5,8.914Z",
    transform: "translate(-3.5 -3.5)",
    fill: "#3260ce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32895_-_Contorno",
    "data-name": "Tracciato 32895 - Contorno",
    d: "M15.1,3.5a1,1,0,0,1,.923,1.385L11.6,15.48a1,1,0,0,1-1.87-.063L8.326,11.27,4.178,9.861a1,1,0,0,1-.063-1.87l10.6-4.414A1,1,0,0,1,15.1,3.5Zm-4.319,8.767,2.462-5.91L7.329,8.819l2.107.716a1,1,0,0,1,.625.625Z",
    transform: "translate(-3.5 -3.5)",
    fill: "#3260ce"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32896",
    "data-name": "Tracciato 32896",
    d: "M19.5,24.746a1.5,1.5,0,0,1-1.061-2.561l3.746-3.746a1.5,1.5,0,0,1,2.121,2.121l-3.746,3.746A1.5,1.5,0,0,1,19.5,24.746Z",
    transform: "translate(-17.895 -12.256)",
    fill: "#3260ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.2aed6863c70da7e7b629b0f9df6d3533.svg";
export { ForwardRef as ReactComponent };